
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePaymentConditionDtoFormGroup() {
return new FormGroup({
    code: new FormControl<string | undefined>('', [Validators.maxLength(30)]),
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    deadlineDays: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    discountDays1: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    discountPercent1: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(100)]),
    discountDays2: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(365)]),
    discountPercent2: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(100)]),
    active: new FormControl<boolean | undefined>(undefined),
    selectable: new FormControl<boolean | undefined>(undefined),
})
;
}
      